module.exports = __webpack_public_path__ + "img/12_no.5d65ec4b.svg";